import * as React from "react";
import "./Dialog.scss";

export interface DialogProps {
    dataId?: any;
    triggerText?: string;
    triggerIcon?: string;
    closeIcon: boolean;
    triggerComponent?: React.ReactNode;
    header?: string;
    dialogStyle?: React.CSSProperties;
    children: React.ReactNode;
    isOpen?: boolean;
}

export const Dialog = (props: DialogProps) => {
    const [isOpen, setIsOpen] = React.useState<boolean>(props.isOpen || false);

    const openDialog = () => {
        setIsOpen(true);
    };

    const closeDialog = (event: any) => {
        if (event.target === event.currentTarget) {
            setIsOpen(false);
        }
    };

    return (
        <div className={"spot-dialog"}>
            {isOpen && (
                <div className="dialog" onClick={closeDialog}>
                    <div className="dialog-content-wrapper" style={props.dialogStyle}>
                        {props.closeIcon && (
                            <span className="close">
                                <i className="icon-cancel-V2" onClick={closeDialog} />
                            </span>
                        )}
                        <div className={"dialog-header"}>
                            <h2>{props.header}</h2>
                        </div>
                        <div className="dialog-content">{props.children}</div>
                    </div>
                </div>
            )}

            <a onClick={openDialog} className={"dialog-trigger"} tabIndex={0}>
                {props.triggerComponent}
                {props.triggerIcon && <i className={props.triggerIcon} />}
                {props.triggerText}
            </a>
        </div>
    );
};
